import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saUeCallDropRateCellChartConfig } from '../cellChartConfigs';

interface UeCallDropRateSaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const UeCallDropRateSaCell: React.FC<UeCallDropRateSaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saUeCallDropRateCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default UeCallDropRateSaCell;
